
import request from '.';

export default function compoundPdf(data) {
  return request({
    url: 'pdf/compound',
    method: 'post',
    data,
  });
}
